<div [fxLayout]="contentAlign === 'RIGHT' ? 'row-reverse' : 'row'"
[fxLayout.xs]="contentAlign === 'RIGHT' ? 'column-reverse' : 'column'">
  <div *ngIf="mediaType === 'VIDEO' && videoUrl"
       class="media-container position-fixed top-0 bottom-0"
       [ngClass]="contentAlign === 'CENTER' ? 'position-fixed top-0 bottom-0'
       : contentAlign === 'LEFT' ? 'fxflex right-0' : 'fxflex left-0'">
    <app-video [videoUrl]="videoUrl" [contentAlign]="contentAlign"></app-video>
  </div>
  <div *ngIf="mediaType === 'IMAGE' && bgUri"
       class="position-fixed top-0 bottom-0 w-full h-full"
       [ngClass]="contentAlign === 'CENTER' ? 'position-fixed top-0 bottom-0'
       : contentAlign === 'LEFT' ? 'fxflex right-0' : 'fxflex left-0'" fxHide.xs>
    <img class="media-container" [src]="bgUri" id="bg" alt="">
  </div>
  <main role="main" class="wrapper-all" [ngClass]="{'fxflex': contentAlign !== 'CENTER'}">
    <div class="bgImage align-center" [ngClass]="{'wrapper-50': contentAlign !== 'CENTER', 'wrapper': contentAlign === 'CENTER'}">
      <mat-card class="content card-border">
          <!--custom globus back button-->
          <a [routerLink]="" *ngIf="!isAppUser" (keydown.enter)="backClick()"  tabindex="0" (click)="backClick()" class="globus-back-btn"><i class="arrow left"></i><span class="hide"><</span> zurück</a>


          <span class="border-cut-top"></span>
          <app-header [logoPosition]="logoPosition" [logoURL]="logoImage" *ngIf="!isAppUser"></app-header>
        <router-outlet></router-outlet>
        <div class="footer">
          <app-footer></app-footer>
        </div>
      </mat-card>

        <!--custom globus footer-->
        <div *ngIf="!isAppUser" class="globus-footer">
        <span class="copyright">
          ©2024 Globus Fachmärkte GmbH & Co. KG
        </span>

            <ul>
                <li><a href="/agb/">AGB</a></li>
                <li><a href="/widerrufsrecht/">Widerrufsrecht</a></li>
                <li><a href="/batterie-elektroruecknahme/">Batterie- & Elektrorücknahme</a></li>
                <li><a href="/altoelentsorgung/">Altölentsorgung</a></li>
                <li><a href="/impressum/">Impressum</a></li>
                <li><a href="/datenschutz/">Datenschutz</a></li>
                <li><a href="/hilfe-kontakt/">Hilfe & Kontakt</a></li>
                <li><a href="https://sicher-melden.de/whistle/#/mainpage/icm53601/globus_fachmaerkte_gmbh_co_kg">Hinweisgebersystem</a></li>
            </ul>
        </div>

    </div>
  </main>
</div>

<div *cidPageLoader="pageLoading"></div>
